import { ResponsiveBar } from '@nivo/bar';
import React from 'react';

import { truncateValue } from '~/utils/helpers';
import GraphTooltip from '~/views/dashboard/DashboardPage/components/AudiencesSection/components/GraphTooltip';

import { ChartTitle, ChartWrapper } from './AIInsightsUI.styles';
import { ColumnChartBlock } from './blockTypes';
import { formatCompactNumber, getCategoryTickRotation, getCategoryTickValues } from './chartAxis';
import {
  CATEGORY_LABEL_MAX_CHARS,
  LABEL_SKIP_WIDTH,
  LEGEND_OFFSET_BOTTOM_NORMAL,
  LEGEND_OFFSET_BOTTOM_ROTATED,
  MARGIN_BOTTOM_NORMAL,
  MARGIN_BOTTOM_ROTATED,
} from './chartConfig';

interface Props {
  block: ColumnChartBlock;
}

const SimpleColumnChart = ({ block }: Props) => {
  const data = block.data.map((d) => ({ label: d.label, value: d.value }));
  const xLabels = data.map((d) => d.label);
  const tickRotation = getCategoryTickRotation(xLabels);

  return (
    <div>
      <ChartTitle>{block.title}</ChartTitle>
      <ChartWrapper>
        <ResponsiveBar
          data={data}
          keys={['value']}
          indexBy="label"
          margin={{ top: 20, right: 20, bottom: tickRotation ? MARGIN_BOTTOM_ROTATED : MARGIN_BOTTOM_NORMAL, left: 60 }}
          axisBottom={{
            legend: block.xLabel,
            legendPosition: 'middle',
            legendOffset: tickRotation ? LEGEND_OFFSET_BOTTOM_ROTATED : LEGEND_OFFSET_BOTTOM_NORMAL,
            tickValues: getCategoryTickValues(xLabels),
            tickRotation,
            format: (v) => (v != null ? truncateValue(String(v), CATEGORY_LABEL_MAX_CHARS) : ''), // see docs/ai-insights-chart-rendering.md §3
          }}
          axisLeft={{
            legend: block.yLabel,
            legendPosition: 'middle',
            legendOffset: -50,
            format: (v) => formatCompactNumber(Number(v)),
          }}
          animate={true}
          colors={['#1784EC']}
          labelTextColor="#ffffff"
          labelSkipWidth={LABEL_SKIP_WIDTH}
          tooltip={(data) => <GraphTooltip dataKey={data.indexValue as string} count={data.value} />}
          theme={{
            axis: {
              ticks: { text: { fontSize: 11, fill: '#6b7280' } },
              legend: { text: { fontSize: 11, fill: '#6b7280' } },
            },
            grid: { line: { stroke: '#f3f4f6' } },
          }}
        />
      </ChartWrapper>
    </div>
  );
};

export default SimpleColumnChart;
